var render = function render(){var _vm=this,_c=_vm._self._c;return _c('em-z-tree',{ref:"deptUserTree",attrs:{"nodeAppender":_vm.appendIcon2UserNodes,"treeNodes":_vm.deptUserTreeNodes,"chkboxType":_vm.chkboxType,"checked-ids":_vm.selectedPrefixId,"enable-auto-expand-checked":"","checkEnable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }